import { dashboardStateName } from './dashboard-routing';

export interface IMenuItem {
  sref?: string;
  title?: string;
  icon?: string;
  roles?: string[];
  unlocked?: boolean;
  isOpened?: boolean;
  children?: IMenuItem[];
  extraClass?: string;
  count?: any;
  key?: string;
}

const sbStateName = 'app.dashboard.small-business';

export const menuItems: IMenuItem[] = [
  {
    title: 'My Profile',
    icon: 'my-profile-item',
    sref: `${dashboardStateName}.profile`,
    roles: [ 'Employer' ]
  },
  {
    title: 'My Profile',
    icon: 'my-profile-item',
    sref: `${dashboardStateName}.cv`,
    roles: [ 'Candidate' ]
  },
  {
    title: 'SMART Services',
    icon: 'smart-services-item',
    sref: `${dashboardStateName}.smart-services`,
    roles: [ 'Candidate', 'Employer' ],
    key: 'smartService'
  },
  {
    title: 'TOP Vacancy',
    icon: 'top-vacancy-item',
    sref: `${dashboardStateName}.top-vacancy`,
    roles: [ 'Candidate', 'Employer' ]
  },
  {
    title: 'Posted Vacancy',
    icon: 'posted-vacancy-item',
    sref: `${dashboardStateName}.posted-vacancy`,
    roles: [ 'Employer' ]
  },
  {
    title: 'TOP Candidate',
    icon: 'top-candidate-item',
    sref: `${dashboardStateName}.top-candidate`,
    roles: [ 'Candidate', 'Employer' ]
  },
  {
    title: 'TOP Employer',
    icon: 'top-employer-item',
    sref: `${dashboardStateName}.top-employer`,
    roles: [ 'Candidate', 'Employer' ]
  },
  {
    title: 'TOP CV',
    icon: 'top-cv-item',
    sref: `${dashboardStateName}.top-cv`,
    roles: [ 'Employer' ],
    key: 'incomingCV',
    children: [
      {
        title: 'Favorite CV',
        sref: `${dashboardStateName}.top-cv.favorite-cv`
      },
      {
        title: 'My Crew',
        sref: `${dashboardStateName}.top-cv.crew`
      },
      {
        title: 'Incoming CV',
        sref: `${dashboardStateName}.top-cv.incoming-cv`,
        key: 'incomingCV'
      }
    ]
  },
  {
    title: 'My Contact list',
    icon: 'top-cv-item',
    sref: `${dashboardStateName}.contact-list`,
    roles: [ 'Candidate' ]
  },
  {
    title: 'Chat',
    icon: 'chat-item',
    sref: `${dashboardStateName}.chat`,
    roles: [ 'Candidate', 'Employer' ],
    key: 'chat'
  },
  {
    title: 'MailBox',
    icon: 'mailbox-item',
    sref: `${dashboardStateName}.mailbox`,
    roles: [ 'Candidate', 'Employer' ],
    key: 'all',
    children: [
      {
        title: 'Admin',
        sref: `${dashboardStateName}.mailbox.admin`,
        key: 'admin'
      },
      // {
      //   title: 'Business',
      //   sref: `${dashboardStateName}.mailbox.business`,
      //   key: 'business'
      // },
      // {
      //   title: 'Finance',
      //   sref: `${dashboardStateName}.mailbox.finance`,
      //   key: 'finance'
      // },
      {
        title: 'Imp Admin',
        sref: `${dashboardStateName}.mailbox.imp-admin`,
        key: 'adminImp'
      },
      // {
      //   title: 'Imp Business',
      //   sref: `${dashboardStateName}.mailbox.imp-business`,
      //   key: 'businessImp'
      // },
      // {
      //   title: 'Imp Finance',
      //   sref: `${dashboardStateName}.mailbox.imp-finance`,
      //   key: 'financeImp'
      // }
    ]
  },
  {
    title: 'My Finance',
    icon: 'my-finance-item',
    sref: `${dashboardStateName}.finance`,
    roles: [ 'Candidate', 'Employer' ]
  }
  //,
  // {
  //   title: 'Business Status',
  //   icon: 'business-status-item',
  //   sref: `${dashboardStateName}.business-status`,
  //   extraClass: 'gold-item',
  //   roles: [ 'Candidate' ]
  // },
  // {
  //   title: 'Candidate Database',
  //   icon: 'business-status-item',
  //   sref: `${dashboardStateName}.business-status`,
  //   extraClass: 'gold-item',
  //   roles: [ 'Employer' ]
  // }
  // ,
  // {
  //   title: 'F.A.Q.',
  //   icon: 'faq-plus-item',
  //   sref: `${dashboardStateName}.faq`,
  //   roles: [ 'Candidate', 'Employer' ]
  // }
  // {
  //   title: 'Playground',
  //   icon: 'faq-plus-item',
  //   sref: `${dashboardStateName}.playground`,
  //   roles: [ 'Candidate', 'Employer' ]
  // }
];

export const smbMenuItems: IMenuItem[] = [
  {
    title: 'Dashboard',
    icon: 'my-profile-item',
    sref: `${sbStateName}.dashboard`
  }
];



// WEBPACK FOOTER //
// ./app/states/dashboard/menu.items.ts